import { fetchEndpoint } from '../server/network'

// 获取购物车商品列表
export const cartGet = () => fetchEndpoint('/v2/ecapi.cart.get', 'POST', {})

// 修改购物车商品数量
export const cartUpdate = (good, amount) =>
	fetchEndpoint('/v2/ecapi.cart.update', 'POST', {
		good: good, // 购物车商品 id
		amount: amount // 数量
	})

// export const cartUpdate = (params) => fetchEndpoint('/v2/ecapi.cart.update', 'POST', params)


// export const getCartGroup = params =>
// 	fetchEndpoint('/v2/ecapi.cart.get', 'POST', params)

// export const updateCartQuantity = params => fetchEndpoint('/v2/ecapi.cart.update', 'post', params)

// export const clearCart = params =>
// 	fetchEndpoint('/v2/ecapi.cart.clear', 'post', params)

// export const getCartPromos = params =>
// 	fetchEndpoint('/v2/ecapi.cart.promos', 'post', params)

// export const checkoutCart = params =>
// 	fetchEndpoint('/v2/ecapi.cart.checkout', 'post', params)



// 获取购物车商品数量   温超二期  2016-8-23
export const cartQuantity = () =>fetchEndpoint('/v2/ecapi.cart.quantity', 'POST', {})

// 添加商品到购物车
export const cartAdd = (product, property, amount) =>
	fetchEndpoint('/v2/ecapi.cart.add', 'POST', {
		product: product, // 在售商品id
		property: property, // 用户选择的属性ID
		amount: amount // 数量
	})

// 从购物车删除删除
export const cartDelete = params => fetchEndpoint('/v2/ecapi.cart.delete', 'POST', params)

// 购物车商品促销信息
export const cartPromos = cart_good_id =>
	fetchEndpoint('/v2/ecapi.cart.promos', 'POST', {
		cart_good_id: cart_good_id // 购物车商品id数组
	})

// 购物车结算
export const cartCheckout = (data) => fetchEndpoint('/v2/ecapi.cart.checkout', 'POST', data)


// WEBPACK FOOTER //
// ./src/api/cart.js